import userApi from '@/api/now/userApi'
import contractsApi from '@/api/now/contractsApi'
import AuthService from '../auth/AuthService'
import ChannelService from '@/service/channeltalk/ChannelService'
import ContractService from '@/service/contract/ContractService'

import router from '@/router'

const isEmpty = (obj) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) { return false }
  }
  return true
}

let userService = {
  patchUser(dataPost) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await userApi.patchMe(dataPost)
        let user = data
        if (user.token) {
          let token = user.token
          let tokenObj = { access_token: token, refresh_token: token, fuser: user }
          AuthService.signinSuccess(tokenObj)
          await AuthService.syncProfile()
        }
        await AuthService.refresh()
        await AuthService.syncProfile()
        ChannelService.boot()
        resolve(user)
      } catch (e) {
        reject(e)
      }
    })
  },
  patchUserStore(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await userApi.patchStore(data)
        await AuthService.refresh()
        await AuthService.syncProfile()
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  putUserCollectionAccount(account) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await userApi.putCollectionAccount(AuthService.getProfile().uuid, account)
        await AuthService.refresh()
        await AuthService.syncProfile()
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  putUserWithdrawalAccount(account) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await userApi.putWithdrawalAccount(AuthService.getProfile().uuid, account)
        await AuthService.refresh()
        await AuthService.syncProfile()
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  postVerifyWithdrawalAccount(verifyWord) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await userApi.postVerifyWithdrawalAccount(AuthService.getProfile().uuid, verifyWord)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  postUserAgents(code) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await contractsApi.postAssignFundaman(code)
        await AuthService.refresh()
        await AuthService.syncProfile()
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  async isExistingCustomer() {
    let data = await ContractService.getCurrentStatus()
    let isExistingCustomer = true
    if (isEmpty(data) || data.status === 'pending') {
      isExistingCustomer = false
    }
    return isExistingCustomer
  },
  async isKycVerified() {
    let user = await AuthService.getProfile()
    let isExistingCustomer = await this.isExistingCustomer()

    if ((!isExistingCustomer && !user.kyc.mobile_verification_is_done) || (isExistingCustomer && (!user.kyc.mobile_verification_is_done || !user.kyc.id_card_verification_is_done || !user.kyc.bank_verification_is_done))) {
      let swal = await window.$swal.fire({
        html: '<h2>고객확인제도 시행</h2><br />특정 금융 거래 정보의 보고 및 이용등에 관한 법률 5조 2항에 따라 본인확인 의무가 강화됩니다. 미 이행 시 대출 진행이 제한됩니다.',
        icon: 'warning',
        confirmButtonText: '본인확인하기',
        allowOutsideClick: false,
      })
      if (swal.isConfirmed) {
        router.push({ name: 'kyc/form' })
      }
    }
  }
}
export default userService
